import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'hr-stats-and-reports-shell',
  templateUrl: './stats-and-reports-shell.component.html',
  styleUrls: ['./stats-and-reports-shell.component.less'],
  standalone: false,
})
export class StatsAndReportsShellComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
